
export default class EmailUtility {
  static isMobileEmail(value: string): boolean {
    const patterns = [
      /softbank/,
      /ezweb/,
      /docomo/,
      /vodafone/,
      /@yahoo\.co\.jp/,
      /@ymobile\.ne\.jp/,
      /@yahoo\.ne\.jp/,
      /@me\.com/,
      /@live\.jp/,
      /@pdx\.ne\.jp/,
    ];
    for (let i = 0; i < patterns.length; i += 1) {
      if (value.match(patterns[i])) {
        return true;
      }
    }
    return false;
  }
}